import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "legend-container d-flex flex-column px-6 py-4 my-4" }
const _hoisted_2 = { class: "label font-weight-bold ml-4" }

import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LegendBox',
  setup(__props) {

const modeColorMap = {
  'origin': '#8c8c8c',
  'fight-fortress': '#ff9924',
  'gold-center': '#fc3232',
  'secret-place': '#3297fc',
  'black-swamp': '#1e1e1e',
  'chance-place': '#0ccb12',
} as const

const modeLabelMap: Record<keyof typeof modeColorMap, string> = {
  'origin': '出生地',
  'fight-fortress': '决战要塞',
  'gold-center': '黄金中心',
  'secret-place': '盲盒秘境',
  'black-swamp': '黑沼泽',
  'chance-place': '机会宝地',
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      "prepend-icon": "mdi-home",
      variant: "text",
      width: "100",
      class: "font-weight-bold",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(_toDisplayString('返回首页'))
      ])),
      _: 1,
      __: [1]
    }),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modeColorMap, (color, mode) => {
      return _createElementVNode("div", {
        class: "legend-item",
        key: mode
      }, [
        _createElementVNode("div", {
          class: "color-box",
          style: _normalizeStyle({ backgroundColor: color })
        }, null, 4),
        _createElementVNode("span", _hoisted_2, _toDisplayString(modeLabelMap[mode] || mode), 1)
      ])
    }), 64))
  ]))
}
}

})